@if (!columnLayout) {
  <div
    class="row gx-2 Control"
    [class.Control--sm]="size === 'small'"
    [class.mb-1]="margin === 'small'"
    [class.mb-3]="margin === 'full'"
  >
    <div class="col col-form-label Control-label">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </div>
    <div class="col Control-input">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
}

@if (columnLayout) {
  <div [class]="'column-control column-control--' + size">
    <div
      class="w-100"
      [class.mb-2]="margin === 'small'"
      [class.mb-4]="margin === 'full'"
    >
      <ng-container *ngTemplateOutlet="label"></ng-container>

      <div class="Control-input">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #label>
  <ng-content select="app-form-label"></ng-content>
</ng-template>
<ng-template #content><ng-content></ng-content></ng-template>
